import { DeleteTwoTone, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Input, Button, DatePicker } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const PositionItem: React.FC<any> = ({
  experienceIndex,
  positionIndex,
  formExpUpdate,
  setFormExpUpdate,
}) => {
  const [isAddSkillInput, setIsAddSkillInput] = useState(false);
  const [newSkill, setNewSkill] = useState("");

  const handleAddSkill = () => {
    const newSkillArr = [
      ...formExpUpdate[experienceIndex].position[positionIndex].skills,
    ];
    newSkillArr.push(newSkill);
    setFormExpUpdate(newSkillArr, "skills", experienceIndex, positionIndex);
    setNewSkill("");
    setIsAddSkillInput(false);
  };

  const handleRemoveSkill = (skillIndex: number) => {
    const updatedItems = formExpUpdate[experienceIndex].position[
      positionIndex
    ].skills.filter((_: any, index: any) => index !== skillIndex);
    setFormExpUpdate(updatedItems, "skills", experienceIndex, positionIndex);
  };

  return (
    <div className="exp-position-item">
      <div className="d-flex justify-content-between align-items-center">
        <Input
          className="fake-input exp-position"
          onChange={(e) => {
            setFormExpUpdate(
              e.target.value,
              "position_name",
              experienceIndex,
              positionIndex
            );
          }}
          value={
            formExpUpdate[experienceIndex].position[positionIndex].position_name
          }
        />
      </div>
      <div className="exp-working-time">
        <RangePicker
          onChange={(dates, dateString) => {
            setFormExpUpdate(
              dateString,
              "date",
              experienceIndex,
              positionIndex
            );
          }}
          defaultValue={[
            dayjs(
              formExpUpdate[experienceIndex].position[positionIndex].start_date
            ),
            dayjs(
              formExpUpdate[experienceIndex].position[positionIndex].end_date
            ),
          ]}
        />
      </div>
      <div className="exp-description">
        <TextArea
          autoSize
          onChange={(e) => {
            setFormExpUpdate(
              e.target.value,
              "description",
              experienceIndex,
              positionIndex
            );
          }}
          className="fake-input"
          value={
            formExpUpdate[experienceIndex].position[positionIndex].description
          }
        />
      </div>
      <div className="exp-skills">
        {formExpUpdate[experienceIndex].position[positionIndex].skills?.map(
          (item: any, index: any) => {
            return (
              <div
                className="exp-skill-item"
                key={index}
                onClick={() => handleRemoveSkill(index)}
              >
                {item}
                <CloseOutlined
                  className="remove-icon"
                  style={{ fontSize: "10px", marginLeft: "3px" }}
                />
              </div>
            );
          }
        )}
        {isAddSkillInput && (
          <Input
            onBlur={() => setIsAddSkillInput(false)}
            onPressEnter={handleAddSkill}
            value={newSkill}
            onChange={(e) => setNewSkill(e.target.value)}
            autoFocus={isAddSkillInput}
            className="exp-skill-item"
          />
        )}
        {!isAddSkillInput && (
          <Button
            className="exp-skill-item"
            onClick={() => setIsAddSkillInput(true)}
          >
            <PlusOutlined />
          </Button>
        )}
      </div>
    </div>
  );
};

export default PositionItem;
